import moment from 'moment';
import { getDSTTimezoneOffsetInSeconds, getTimezoneOffsetInSeconds } from '.';
import { intervalsDate } from '../constants/analytics.constants';

export const setSearchParameter = (name, value) => {
  let url = new URL(window.location.href);
  url.searchParams.set(name, value);
  return url.pathname + url.search;
};

export const deleteSearchParameters = (names) => {
  let url = new URL(window.location.href);
  names.forEach((item) => url.searchParams.delete(item));
  return url.pathname + url.search;
};

export const getSearchParameter = (name) => {
  let url = new URL(window.location.href);
  return url.searchParams.get(name);
};

export const getSearchParametersSize = () => {
  let url = new URL(window.location.href);
  return url.searchParams.size;
};

export const checkSearchParameter = (name) => {
  let url = new URL(window.location.href);
  return url.searchParams.has(name);
};

export const checkSearchString = () => {
  let url = new URL(window.location.href);
  return url.search.length !== 0;
};

export const setSearchParameters = (names, values, removeNames = []) => {
  let url = new URL(window.location.href);
  removeNames.forEach((item) => url.searchParams.delete(item));
  values.forEach((item, index) => {
    if (item !== null) url.searchParams.set(names[index], item);
    else url.searchParams.delete(names[index]);
  });
  return url.pathname + url.search;
};

export const getStartDate = (startDate, timeInterval, timezone) => {
  if (!!timeInterval) {
    const date = new Date(
      moment().valueOf() -
        timeInterval * 1000 -
        getTimezoneOffsetInSeconds(Intl.DateTimeFormat().resolvedOptions().timeZone)
    );

    return date.toISOString();
  } else if (startDate !== 'select') {
    const date = new Date(startDate - getTimezoneOffsetInSeconds(timezone));
    return date.toISOString();
  }
  return null;
};

export const getStartDateDST = (startDate, timeInterval, timezone) => {
  if (!!timeInterval) {
    const offset = getDSTTimezoneOffsetInSeconds(startDate, Intl.DateTimeFormat().resolvedOptions().timeZone);
    const ts = moment().valueOf() - timeInterval * 1000 - offset;
    const date = new Date(ts);
    
    return date.toISOString();
  } else if (startDate && startDate !== 'select') {
    const ts = startDate - getDSTTimezoneOffsetInSeconds(startDate, timezone);
    const date = new Date(ts);
    
    return date.toISOString();
  }
  
  return null;
};

export const getEndDate = (endDate, timeInterval, timezone, extraTime = 0) => {
  if (!!timeInterval) {
    const date = new Date(
      moment().valueOf() -
        getTimezoneOffsetInSeconds(Intl.DateTimeFormat().resolvedOptions().timeZone) +
        extraTime
    );

    return date.toISOString();
  } else if (endDate !== 'select') {
    const date = new Date(endDate - getTimezoneOffsetInSeconds(timezone) + extraTime);
    return date.toISOString();
  }
};

export const getEndDateDST = (endDate, timeInterval, timezone) => {
  if (!!timeInterval) {
    const offset = getDSTTimezoneOffsetInSeconds(endDate, Intl.DateTimeFormat().resolvedOptions().timeZone);
    const ts = moment().valueOf() - offset;
    const date = new Date(ts);
    
    return date.toISOString();
  } else if (endDate && endDate !== 'select') {
    const ts = endDate - getDSTTimezoneOffsetInSeconds(endDate, timezone);
    const date = new Date(ts);
    
    return date.toISOString();
  }
  
  return null;
};


export const hasTodayQueryParam = () => {
  const today = getSearchParameter('today');
  return today === 'true';
}

export const changeSearchDateString = (
  startDate,
  endDate,
  arrowInterval,
  defaultValue,
  withoutTime = false,
  allowFuture = false
) => {
  const condition = startDate &&
    startDate !== 'select' && startDate !== 'today' &&
    (defaultValue === null ||
      (startDate !== defaultValue &&
        (endDate === null ||
          moment(endDate).isBefore(moment(), withoutTime ? 'day' : 'minute') ||
          allowFuture)) ||
      (startDate === defaultValue && endDate !== null));
  
  if (condition) {
    return intervalsDate.find((interval) => interval.icon === startDate) && endDate === null
      ? setSearchParameters(['timeInterval'], [startDate], ['startDate', 'endDate', 'interval', 'today'])
      : arrowInterval !== null
        ? setSearchParameters(
          ['startDate', 'endDate', 'interval'],
          [
            moment(startDate).format(withoutTime ? 'YYYY-MM-DD' : 'x'),
            moment(endDate).format(withoutTime ? 'YYYY-MM-DD' : 'x'),
            arrowInterval,
          ],
          ['timeInterval', 'today']
        )
        : setSearchParameters(
          ['startDate', 'endDate'],
          [
            moment(startDate).format(withoutTime ? 'YYYY-MM-DD' : 'x'),
            moment(endDate).format(withoutTime ? 'YYYY-MM-DD' : 'x'),
          ],
          ['timeInterval', 'interval', 'today']
        );
  } else {
    if (startDate === 'today') {
      return setSearchParameters(
        ['today'],
        [true],
        ['startDate', 'endDate', 'timeInterval', 'interval']
      )
    }
    
    return deleteSearchParameters(['startDate', 'endDate', 'timeInterval', 'interval', 'today']);
  }
};
